var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "form-group date_range" }, [
      _vm.title
        ? _c("label", { attrs: { for: "" } }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group" },
        [
          _c("datetime", {
            attrs: {
              id: "start_range",
              "input-class": "form-control",
              type: "date",
              "minute-step": 60,
              format: "dd.MM.yyyy",
              auto: true,
            },
            model: {
              value: _vm.range.start,
              callback: function ($$v) {
                _vm.$set(_vm.range, "start", $$v)
              },
              expression: "range.start",
            },
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("datetime", {
            attrs: {
              id: "end_range",
              "input-class": "form-control",
              type: "date",
              "minute-step": 60,
              format: "dd.MM.yyyy",
              auto: true,
            },
            model: {
              value: _vm.range.end,
              callback: function ($$v) {
                _vm.$set(_vm.range, "end", $$v)
              },
              expression: "range.end",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "input-group-prepend input-group-append" },
      [_c("span", { staticClass: "input-group-text" }, [_vm._v("по")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }